import { Radio, RadioGroupProps } from 'antd';
import { FC } from 'react';

const DgRadioButtonGroup: FC<RadioGroupProps> = ({ children, ...props }) => {
	return <Radio.Group {...props}>{children}</Radio.Group>;
};

export default DgRadioButtonGroup;
